import script from "./CustomMultiSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomMultiSelect.vue?vue&type=script&setup=true&lang=js"

import "./CustomMultiSelect.vue?vue&type=style&index=0&id=f5f21a88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5f21a88"]])

export default __exports__